export const createToast = ({ message, variant }) => {
  const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="-close"> <path d="M5 5L12 12M12 12L19 5M12 12L5 19M12 12L19 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </svg>`
  const toastIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" aria-hidden="true" class="-icon"> <path d="M24.9987 49.1666C11.6514 49.1666 0.832031 38.3472 0.832031 24.9999C0.832031 11.6527 11.6514 0.833252 24.9987 0.833252C38.3459 0.833252 49.1654 11.6527 49.1654 24.9999C49.1654 38.3472 38.3459 49.1666 24.9987 49.1666ZM22.5893 34.6666L39.6751 17.5783L36.2579 14.1612L22.5893 27.8323L15.7525 20.9955L12.3354 24.4127L22.5893 34.6666Z"></path> </svg>`

  const template = `
  <div class="flash-message__inner">
    <div class="flash-message__message">
      ${toastIcon}
      <span>${message}</span>
      ${closeIcon}
    </div>
  </div>`

  const anyToastsEl = document.querySelectorAll(
    `.flash-message.flash-message--notice, .flash-message.flash-message--alert`
  )

  if (anyToastsEl.length > 0) {
    anyToastsEl.forEach((el) => {
      el.remove()
    })
  }

  const usedVariant = variant || `notice`

  const toast = document.createElement(`div`)
  toast.className = `flash-message flash-message--${usedVariant}`
  // A toast is the only feedback for some actions, so it has to be announced.
  // Failures interrupt (`alert`); confirmations wait their turn (`status`).
  toast.setAttribute(`role`, usedVariant === `alert` ? `alert` : `status`)
  toast.innerHTML = template
  document.body.appendChild(toast)
  window.dispatchEvent(new Event(`toast:added`))
}
